angular.module('logbook')
.directive('exposeState',function(){
  return {
      require:'stTable',
      link:function(scope, element, attr, ctrl){
         scope.smartTableState=ctrl.tableState();
         if( scope.smartTableCtrlContainer && attr.id)
            scope.smartTableCtrlContainer[attr.id] = ctrl;
      }
  };
});